import { AppShell, rem } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { NavbarBottom } from './NavbarBottom';
import { NavbarMenu } from './NavbarMenu';
import { NavbarTop } from './NavbarTop';
export const Navbar: React.FC = () => {
  const isMobile = useMediaQuery('(max-width: 75em)');
  return <AppShell.Navbar p="md" pt="md" withBorder={false} maw={287} style={{
    zIndex: 10
  }}>
      <AppShell.Section bg={{
      base: 'var(--navbar-bg-color)',
      lg: 'transparent'
    }} style={{
      borderTopLeftRadius: rem(5),
      borderTopRightRadius: rem(5)
    }}>
        <NavbarTop />
      </AppShell.Section>

      <AppShell.Section grow mt={{
      base: 0,
      lg: 20
    }} p={{
      base: 'md',
      sm: 17
    }} px={8} h="100%" pos="relative" bg="var(--navbar-bg-color)"
    // component={ScrollArea}
    // scrollbars="y"
    style={{
      borderTopLeftRadius: isMobile ? rem(0) : rem(5),
      borderTopRightRadius: isMobile ? rem(0) : rem(5)
    }}>
        <NavbarMenu />
      </AppShell.Section>

      <AppShell.Section p="md" bg="var(--navbar-bg-color)" style={{
      borderBottomLeftRadius: rem(5),
      borderBottomRightRadius: rem(5)
    }}>
        <NavbarBottom />
      </AppShell.Section>
    </AppShell.Navbar>;
};